// WeekdayNumber = 0 | 1 | 2 | 3 | 4 | 5 | 6
export const getWeekdayInString = (weekdayNumber) => {
  const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  return weekdays[weekdayNumber];
};
